import swal from "sweetalert";
import { updateRequest } from '../dataApi'

export const generatePurchaseOrder = async (request) => {
    const setFinal = await swal({text: "Se procede a generar la Orden de Compra, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"],})
    
    if(!setFinal) return false

    await updateRequest({
        id: request,
        purchaseOrder: true,
        status: 'EN PROCESO DE COMPRA'
    })

    return true
}